import {
  Card,
  CardActionArea,
  CardContent,
  Grid2 as Grid,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import StateLabel from "../../../components/StateLabel";
import { DateTime } from "luxon";
import type { LeavingQuestionnaireListItem } from "../../../utils/Types/LeavingQuestionnaireType";

interface LeavingQuestionnaireEntryType {
  questionnaire: LeavingQuestionnaireListItem;
}

const LeavingQuestionnaireEntry = ({
  questionnaire,
}: LeavingQuestionnaireEntryType) => {
  const navigate = useNavigate();

  const handleClickQuestionnaire = () => {
    navigate("/dotaznikvystup/" + questionnaire.id + "/uvod");
  };

  return (
    <Card variant="outlined">
      <CardActionArea onClick={handleClickQuestionnaire}>
        <CardContent>
          <Grid container justifyItems="center">
            <Grid sx={{ flex: 1 }}>
              <Typography variant="h3">Dotazník</Typography>
            </Grid>
            <Grid>
              <StateLabel state={questionnaire.state} />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <br />
              Vytvořen:{" "}
              <b>
                {DateTime.fromISO(questionnaire.createdAt).isValid ? (
                  DateTime.fromISO(questionnaire.createdAt).toFormat(
                    "d.M.yyyy"
                  )
                ) : (
                  <i>neuvedeno</i>
                )}
              </b>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default LeavingQuestionnaireEntry;
